/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Drive_Search_SuccessInputs */

const es_tools_drive_search_success = /** @type {(inputs: Tools_Drive_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda en Drive completada`)
};

const en_tools_drive_search_success = /** @type {(inputs: Tools_Drive_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive search complete`)
};

/**
* | output |
* | --- |
* | "Drive search complete" |
*
* @param {Tools_Drive_Search_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_drive_search_success = /** @type {((inputs?: Tools_Drive_Search_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Drive_Search_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_drive_search_success(inputs)
	return en_tools_drive_search_success(inputs)
});
export { tools_drive_search_success as "tools.drive.search_success" }